<template>
  <v-container
    class="pt-0"
    v-if="!$store.state.consumers.loading && !$store.state.messages.loading"
  >
    <v-card class="elevation-12 mx-auto">
      <v-toolbar dark color="user_primary">
        <v-toolbar-title class="text-sm-h5 mx-auto"
          >Contact Hairdreams</v-toolbar-title
        >
      </v-toolbar>
      <v-card-text>
        <v-container>
          <v-row>
            <v-col cols="6">
              <v-text-field
                auto-resize
                hide-details
                label="First name"
                v-model="message.firstName"
              >
              </v-text-field>
            </v-col>

            <v-col cols="6">
              <v-text-field
                hide-details
                label="Last name"
                v-model="message.lastName"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <VuePhoneNumberInput
                show-code-on-list
                v-model="message.phone"
                no-example
                default-country-code="US"
                :only-countries="['US', 'CA']"
                :size="detectMob() ? 'sm' : 'lg'"
                color="#222"
                valid-color="#222"
                error-color="red"
                height="100"
                :no-flags="detectMob() ? true : false"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="9">
              <v-text-field
                hide-details
                label="Email"
                v-model="message.email"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="3">
              <v-text-field
                hide-details
                label="Zip"
                v-model="message.zip"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-select
                class="text-truncate"
                v-model="message.topic"
                :items="Object.values(ContactMessageSalonTopics)"
                item-text="text"
                item-value="value"
                label="Topic"
              >
              </v-select>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="12">
              <v-textarea
                filled
                outlined
                prepend-inner-icon="mdi-comment"
                hide-details
                auto-grow
                name="input-7-1"
                label="Message"
                placeholder="Write us a message"
                v-model="message.body"
              ></v-textarea>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-checkbox
                v-model="message.sendPromotion"
                label="I want to receive promotional emails" /></v-col
          ></v-row>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <!-- <v-btn rounded @click="onClose"> Close </v-btn> -->
        <v-btn
          class="white--text"
          rounded
          color="user_primary"
          @click="onSend"
          :disabled="!isValid"
          :loading="isSending"
          >Send
        </v-btn>
      </v-card-actions>
    </v-card>

    <SimpleModal
      :showDialog="responseDialog"
      :message="responseMessage"
      @closeSimpleModal="closeResponseDialog"
    />
  </v-container>
</template>

<script>
  import { mapActions } from 'vuex'
  import {
    MessageFrom,
    ContactMessageSources,
    ContactMessageSalonTopics,
    MessageTypes,
    ThankYouPageSources
  } from '../../config/enums'
  import { detectMob } from '@/utils/helpers'

  export default {
    data() {
      return {
        ContactMessageSalonTopics,
        detectMob,
        isSending: false,
        responseMessage: '',
        responseDialog: false,
        message: {
          type: MessageTypes.C_H,
          from: MessageFrom.C,
          source: '',
          topic: '',
          firstName: '',
          lastName: '',
          phone: '',
          email: '',
          consumer: '',
          body: '',
          zip: '',
          sendPromotion: false
        }
      }
    },

    computed: {
      consumer() {
        return this.$store.state.consumers.consumer
      },
      isValid() {
        return (
          !!this.message.firstName &&
          !!this.message.lastName &&
          !!this.message.phone &&
          !!this.message.email &&
          // !!this.message.consumer &&
          !!this.message.type &&
          !!this.message.body &&
          !!this.message.topic &&
          !!this.message.zip
        )
      }
    },
    methods: {
      ...mapActions(['send_c_h', 'fetchConsumer']),
      closeResponseDialog() {
        this.responseDialog = false
        this.onClose()
      },
      async onSend() {
        if (this.isValid) {
          this.isSending = true
          // don't send empty consumer
          if (!this.message.consumer) {
            delete this.message.consumer
          }
          await this.send_c_h(this.message)
          if (!this.$store.state.messages.error) {
            this.responseMessage = 'Message has been sent!'
            this.responseDialog = true
            this.dialog = false
            this.$router.replace({
              name: 'ThankYouPage',
              params: { source: ThankYouPageSources.contact }
            })
          }
          this.isSending = false
        }
      }
    },
    async created() {
      if (this.$route.params.consumerId) {
        if (!this.$store.state.consumers.consumer) {
          await this.fetchConsumer(this.$route.params.consumerId)
        }
        this.message.firstName = this.consumer.firstName
        this.message.lastName = this.consumer.lastName
        this.message.phone = this.consumer.phone
        this.message.email = this.consumer.email
        this.message.zip = this.consumer.zip
        this.message.consumer = this.$route.params.consumerId
      }
      this.message.source = this.$route.query.source
      if (this.message.source === ContactMessageSources.declined_terms) {
        this.message.topic = ContactMessageSalonTopics.TERMS
      }
    }
  }
</script>
